import { render } from "./ChatComposer.vue?vue&type=template&id=6a86527e&scoped=true"
import script from "./ChatComposer.vue?vue&type=script&lang=js"
export * from "./ChatComposer.vue?vue&type=script&lang=js"

import "./ChatComposer.vue?vue&type=style&index=0&id=6a86527e&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a86527e"]])

export default __exports__